// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attachments ::ng-deep p {
  font-size: 16px;
  font-weight: bold;
}
.attachments ::ng-deep .attachment-title {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/news/details/news-detail/news-detail.component.scss"],"names":[],"mappings":"AAEQ;EACI,eAAA;EACA,iBAAA;AADZ;AAGQ;EACI,eAAA;AADZ","sourcesContent":[".attachments {\n    ::ng-deep {\n        p {\n            font-size: 16px;\n            font-weight: bold;\n        }\n        .attachment-title {\n            font-size: 14px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
